var userList = new List('jobDesListId',  {
    valueNames: ['name'],
    page: 30,
    pagination: true
});
function filterByAlphabet(startArray){
    var alphaPostsSearch = document.getElementById('alphaposts-search');
    if (alphaPostsSearch && userList.searched) {
        // clear search
        alphaPostsSearch.value = '';
        userList.fuzzySearch();
    }

    // filter by letters
    userList.filter(function(item) {
        if ($.inArray(item.values().name.charAt(0), startArray)!= -1) {
            return true;
        }
        else {
            return false;
        }
    });
}
function alphapostsReady() {
    var alphaPostsSearch = document.getElementById('alphaposts-search'),
        alphaPostsNoResults = document.getElementById('alphaposts-no-results');

    function doSearch(e) {
        if (userList.filtered) {
            // clear filter
            userList.filter();
        }
        userList.fuzzySearch(e.target.value.trim(), ['name']);
        return false;
    }
    if (alphaPostsSearch) {
        alphaPostsSearch.addEventListener('input', doSearch);
    }

    function showHideNoResults(e) {
        alphaPostsNoResults.style.display = (e.visibleItems.length === 0) ? 'block' : 'none';
    }
    if (alphaPostsNoResults) {
        userList.on('searchComplete', showHideNoResults);
        userList.on('filterComplete', showHideNoResults);
    }
}
document.addEventListener("DOMContentLoaded", alphapostsReady);